export default {
  login: {
    title: "Willkommen zurück",
    // Der Tab-Titel. Die Überschrift ist eine Begrüßung und benennt die Seite nicht.
    page_title: "Anmelden",
    subtitle: "Melden Sie sich in Ihrem Account an, um fortzufahren",
    form: {
      email: "E-Mail",
      password: "Passwort",
      submit: "Einloggen",
    },
    // Only shown to somebody who belongs to more than one company, and only after their password
    // has been accepted.
    choose_workspace: "Für welchen Arbeitsbereich möchten Sie sich anmelden?",
    back_to_login: "Zurück zur Anmeldung",
    session_expired: "Ihre Sitzung ist abgelaufen.",
    // Erscheint, nachdem "Arbeitsbereich wechseln" im Benutzermenü zur Auswahl hierher abgemeldet hat.
    switch_workspace: "Geben Sie Ihr Passwort ein, um sich in einem anderen Arbeitsbereich anzumelden.",
    // Antwort auf 429 vom Backend (LoginAttemptThrottle). Bewusst NICHT die Meldung "falsches
    // Passwort": das Passwort wurde gar nicht geprüft, und es kann durchaus das richtige gewesen sein.
    too_many_attempts:
      "Zu viele fehlgeschlagene Anmeldeversuche. Bitte versuchen Sie es in {minutes} Minute(n) erneut.",
    forgot_password: "Passwort vergessen?",
    no_account: "Sie haben noch keinen Account?",
    create_account: "Erstellen Sie hier einen.",
  },
  register: {
    title: "Registrierung",
    subtitle: "Erstellen Sie einen neuen Account",
    existing_account:
      "Für diese E-Mail-Adresse besteht bereits ein Konto. Geben Sie dessen Passwort ein, um dieses Unternehmen hinzuzufügen.",
    steps: {
      account: "Konto",
      company: "Unternehmen",
    },
    form: {
      back: "Zurück",
      next: "Weiter",
      email: "E-Mail",
      firstName: "Vorname",
      lastName: "Nachname",
      password: "Passwort",
      company: {
        name: "Unternehmens Name",
      },
      address: {
        title: "Unternehmens Adresse",
        street: "Straße",
        houseNumber: "Hausnummer",
        postcode: "PLZ",
        place: "Ort",
        country: "Land",
      },
      submit: "Registrieren",
    },
    registerNotice: "Mit Ihrer Anmeldung stimmen Sie dem zu",
    termsOfUse: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutz-Bestimmungen",
    alreadyAccount: "Besitzen Sie schon einen Account?",
    loginRedirect: "Melden Sie sich hier an.",
  },
  forgot_password: {
    title: "Passwort vergessen",
    subtitle:
      "Geben Sie die E-Mail-Adresse Ihres Kontos ein und wir senden Ihnen eine Mail zum Zurücksetzen Ihres Passworts.",
    form: {
      email: "E-Mail",
      submit: "Passwort zurücksetzen",
    },
    back_to_login: "Zurück zur Anmeldung.",
    sent: {
      title: "Überprüfen Sie Ihre Mails",
      subtitle: "Öffnen Sie den Link, den Sie per E-Mail erhalten haben, und setzen Sie Ihr Account-Passwort zurück.",
      resend: "E-Mail erneut senden.",
    },
  },
  reset_password: {
    title: "Geben Sie Ihr neues Passwort ein",
    // Der Tab-Titel — die Überschrift ist eine Aufforderung, zu lang für einen Tab.
    page_title: "Passwort zurücksetzen",
    subtitle: "Setzen Sie Ihr aktuelles Passwort neu.",
    form: {
      password: "Neues Passwort",
      submit: "Neues Passwort speichern",
    },
  },
  password_success: {
    title: "Passwort erfolgreich geändert",
    subtitle: "Sie haben Ihr Passwort erfolgreich geändert. Sie können sich nun mit Ihrem neuen Passwort anmelden.",
    to_login: "Zum Login",
  },
}
